const PAGE_CHIPS = ["Home", "Sign up", "Pricing"];

export default function HowItWorksFindMock() {
  return (
    <div className="max-w-full overflow-hidden rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <p className="truncate text-base text-gray-600">yourproduct.com</p>
      <div className="mt-3 flex flex-wrap gap-2 border-t border-gray-100 pt-3">
        {PAGE_CHIPS.map((label) => (
          <span key={label} className="rounded-md bg-primary-50 px-2 py-1 text-xs font-semibold text-primary-700">
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
